import { defineStore } from 'pinia';
import { defaultStag, stagAfter14days } from '~/config/constants.config';
import { getCookieValue, rootDomain } from '~/utils/cookie';
import { useClickTracker } from '../../composables/useClickTracker';
import { useStoreSsLocales } from '../softswiss/locales';
import { useStoreSsPlayer } from '../softswiss/player';

const stagToPureStag = (stag: string) => {
  const splittedStag = String(stag).split('_');
  if (splittedStag && splittedStag.length) {
    return splittedStag[0];
  }
  return '';
};

export const useStoreStag = defineStore('clientStag', {
  state: () => ({
    stag: '',
    lastSavedStag: '',
    wasRegisteredByPureStag: '',
    uniq_id: '',
  }),

  getters: {
    currentStag(state): string {
      if (state.stag && !state.stag.includes('_')) {
        return state.stag + '_noclickid';
      }
      return state.stag;
    },

    currentPureStag(): string {
      return stagToPureStag(this.currentStag || localStorage.stag || '');
    },
  },

  actions: {
    checkStag(stag?: string) {
      const player = useStoreSsPlayer();

      if (!import.meta.browser || player.isPlayerAuthorised) {
        return;
      }

      if (!window || !window.location) {
        return;
      }

      useClickTracker().generateAndStoreUniqId();

      const urlQueryParams = new URLSearchParams(window.location.search);

      const refCodeValue = urlQueryParams.get('ref_code');
      if (refCodeValue) {
        useStoreSsLocales().saveRefCode(refCodeValue);
      }

      if (refCodeValue || getCookieValue('ref_code')) {
        this.stag = '';
        this.wasRegisteredByPureStag = '';
        localStorage.removeItem('stag');

        if (getCookieValue('stag')) {
          const domain = rootDomain(document.location.host);
          document.cookie = `stag=; max-age=-1000; domain=${domain}; path=/;`;
        }

        return;
      }

      const stagParams = window.location.href.match(/stag=(\d+(_[\d\w]+)?)/);
      if (stagParams && stagParams[1]) {
        this.stag = stagParams[1];
      } else if (stag) {
        this.stag = stag;
      }

      if (localStorage && this.currentStag) {
        localStorage.stag = this.currentStag;
      }

      if (this.currentStag) {
        useStoreSsLocales().saveStag(this.currentStag, useStoreStag().uniq_id);

        if (!getCookieValue('stag-lifetime')) {
          const expire = new Date();
          expire.setMonth(expire.getMonth() + 1);
          window.document.cookie = `stag-lifetime=${
            Date.now() + 1209600000
          };expires=${expire.toUTCString()};Path=/`;
        }
      }

      const stagLifetime = getCookieValue('stag-lifetime');

      const isExpiredStag = stagLifetime && Number(stagLifetime) < Date.now();

      if (
        isExpiredStag ||
        (!urlQueryParams.has('stag') &&
          // !this.stag &&
          // !this.currentStag &&
          // !localStorage.stag &&
          !getCookieValue('stag'))
      ) {
        const stag = isExpiredStag ? stagAfter14days : defaultStag;
        useStoreSsLocales().saveStag(stag, useStoreStag().uniq_id);
        localStorage.setItem('stag', stag);

        this.stag = stag;
        window.document.cookie = `stag-lifetime=;Max-Age=-1000;Path=/`;
      }
    },

    setStag(stag: string) {
      useStoreSsLocales().saveStag(stag, useStoreStag().uniq_id);
      localStorage.setItem('stag', stag);

      this.stag = stag;
      window.document.cookie = `stag-lifetime=;Max-Age=-1000;Path=/`;

      this.lastSavedStag = stag;
    },

    /*
    Sometimes we need to know if user had stag in past
    for example to show sign_up modal if user reloads page
    */
    checkPureStagByWhichWasRegistered() {
      if (localStorage && localStorage?.stag) {
        this.wasRegisteredByPureStag = stagToPureStag(localStorage.stag);
      }
    },

    setUniqId(payload: string) {
      this.uniq_id = payload;
    },
  },
});
